import "../common/ImportMeta";

import LockReset from "@mui/icons-material/LockReset";
import Button, { type ButtonProps } from "@mui/material/Button";
import React from "react";
import { useTranslation } from "react-i18next";

import type { JSX } from "react";

export type ChangePasswordLinkProps = {
	/**
	 * Additional Material-UI Button props
	 */
	buttonProps?: Omit<ButtonProps, "onClick">;
};

export const handleChangePassword = (): void => {
	const keycloakUrl = import.meta.env.VITE_KEYCLOAK_URL;
	const realm = import.meta.env.VITE_KEYCLOAK_REALM;
	const clientId = import.meta.env.VITE_KEYCLOAK_CLIENT_ID;
	const redirectUri = encodeURIComponent(window.location.origin);

	const url =
		`${keycloakUrl}/realms/${realm}/protocol/openid-connect/auth?` +
		`client_id=${clientId}&` +
		`redirect_uri=${redirectUri}&` +
		`response_type=code&` +
		`scope=openid&` +
		`kc_action=UPDATE_PASSWORD`;

	window.location.href = url;
};

/**
 * Button component that redirects the user to Keycloak's password change page.
 * After changing the password, the user will be redirected back to the current origin.
 */
export function ChangePasswordLink({ buttonProps }: ChangePasswordLinkProps): JSX.Element {
	const { t } = useTranslation();

	return (
		<Button
			variant="outlined"
			startIcon={<LockReset />}
			onClick={handleChangePassword}
			{...buttonProps}>
			{t("change-password")}
		</Button>
	);
}
